// CoinMarketCap supported languages configuration
// Extracted directly from https://coinmarketcap.com/

export const CMC_LANGUAGES = [
  {
    code: "en",
    name: "English",
    englishAbbreviation: "English",
    countryFlag: "US",
    hreflang: "en"
  },
  {
    code: "ar",
    name: "اَلْعَرَبِيَّةُ",
    englishAbbreviation: "Arabic",
    countryFlag: "AR",
    hreflang: "ar",
    isRtl: true
  },
  {
    code: "bg",
    name: "български",
    englishAbbreviation: "Bulgarian",
    countryFlag: "BG",
    hreflang: "bg"
  },
  {
    code: "cs",
    name: "Čeština",
    englishAbbreviation: "Czech",
    countryFlag: "CZ",
    hreflang: "cs"
  },
  {
    code: "da",
    name: "Dansk",
    englishAbbreviation: "Danish",
    countryFlag: "DK",
    hreflang: "da"
  },
  {
    code: "de",
    name: "Deutsch",
    englishAbbreviation: "German",
    countryFlag: "DE",
    hreflang: "de"
  },
  {
    code: "el",
    name: "ελληνικά",
    englishAbbreviation: "Greek",
    countryFlag: "EL",
    hreflang: "el"
  },
  {
    code: "es",
    name: "Español",
    englishAbbreviation: "Spanish",
    countryFlag: "ES",
    hreflang: "es"
  },
  {
    code: "fi",
    name: "Suomeksi",
    englishAbbreviation: "Finnish",
    countryFlag: "FI",
    hreflang: "fi"
  },
  {
    code: "fr",
    name: "Français",
    englishAbbreviation: "French",
    countryFlag: "FR",
    hreflang: "fr"
  },
  {
    code: "hi",
    name: "हिन्दी",
    englishAbbreviation: "Hindi",
    countryFlag: "IN",
    hreflang: "hi"
  },
  {
    code: "hu",
    name: "Magyar",
    englishAbbreviation: "Hungarian",
    countryFlag: "HU",
    hreflang: "hu"
  },
  {
    code: "id",
    name: "Bahasa Indonesia",
    englishAbbreviation: "Indonesian",
    countryFlag: "ID",
    hreflang: "id"
  },
  {
    code: "it",
    name: "Italiano",
    englishAbbreviation: "Italian",
    countryFlag: "IT",
    hreflang: "it"
  },
  {
    code: "ja",
    name: "日本語",
    englishAbbreviation: "Japanese",
    countryFlag: "JP",
    hreflang: "ja"
  },
  {
    code: "ko",
    name: "한국어",
    englishAbbreviation: "Korean",
    countryFlag: "KR",
    hreflang: "ko"
  },
  {
    code: "nl",
    name: "Nederlands",
    englishAbbreviation: "Dutch",
    countryFlag: "NL",
    hreflang: "nl"
  },
  {
    code: "no",
    name: "Norsk",
    englishAbbreviation: "Norwegian",
    countryFlag: "NO",
    hreflang: "no"
  },
  {
    code: "pl",
    name: "Język polski",
    englishAbbreviation: "Polish",
    countryFlag: "PL",
    hreflang: "pl"
  },
  {
    code: "pt-br",
    name: "Português Brasil",
    englishAbbreviation: "Portuguese",
    countryFlag: "BR",
    hreflang: "pt-br"
  },
  {
    code: "ro",
    name: "Română",
    englishAbbreviation: "Romanian",
    countryFlag: "RO",
    hreflang: "ro"
  },
  {
    code: "ru",
    name: "Русский",
    englishAbbreviation: "Russian",
    countryFlag: "RU",
    hreflang: "ru"
  },
  {
    code: "sk",
    name: "Slovenčina",
    englishAbbreviation: "Slovak",
    countryFlag: "SK",
    hreflang: "sk"
  },
  {
    code: "sv",
    name: "Svenska",
    englishAbbreviation: "Swedish",
    countryFlag: "SE",
    hreflang: "sv"
  },
  {
    code: "th",
    name: "ไทย",
    englishAbbreviation: "Thai",
    countryFlag: "TH",
    hreflang: "th"
  },
  {
    code: "tr",
    name: "Türkçe",
    englishAbbreviation: "Turkish",
    countryFlag: "TR",
    hreflang: "tr"
  },
  {
    code: "uk",
    name: "Українська",
    englishAbbreviation: "Ukrainian",
    countryFlag: "UA",
    hreflang: "uk"
  },
  {
    code: "ur",
    name: "اُردُو",
    englishAbbreviation: "Urdu",
    countryFlag: "PK",
    hreflang: "ur",
    isRtl: true
  },
  {
    code: "vi",
    name: "Tiếng Việt",
    englishAbbreviation: "Vietnamese",
    countryFlag: "VN",
    hreflang: "vi"
  },
  {
    code: "zh",
    name: "简体中文",
    englishAbbreviation: "Simplified Chinese",
    countryFlag: "CN",
    hreflang: "zh"
  },
  {
    code: "zh-tw",
    name: "繁體中文",
    englishAbbreviation: "Traditional Chinese",
    countryFlag: "TW",
    hreflang: "zh-tw"
  }
];

export const CMC_LANGUAGE_CODES = CMC_LANGUAGES.map((l) => l.code);
